import { Link } from "react-router-dom";
import beachhaven from "./images/beachhaven/beach haven icon.jpg";
import bigblue from "./images/bigblue/big blue icon.jpg";
import RentalCard from "./components/RentalCard";
import { useEffect } from "react";
import ReviewSlider from "./components/ReviewSlider/ReviewSlider";

const Home = () => {
  useEffect(() => {
    document.title = "Rest and Relax";
  }, []);

  return (
    <div className="flex flex-col items-center justify-center w-[80%]">
      <h2 className="heading-xl">rentals</h2>
      <div className="w-[90%] mb-4">
        <ReviewSlider></ReviewSlider>
      </div>
      <div className="flex flex-wrap lg:flex-nowrap justify-center">
        <Link
          className="basis-full lg:basis-1/2 lg:mb-0 mb-8 mx-8"
          to="/bigblue"
          onClick={() => window.scrollTo(0, 0)}
        >
          <RentalCard
            image={bigblue}
            name="Big Blue"
            houseType="Beach house"
            location="Fort Morgan"
          />
        </Link>
        <Link
          className="basis-full lg:basis-1/2 mx-8"
          to="/beachhaven"
          onClick={() => window.scrollTo(0, 0)}
        >
          <RentalCard
            image={beachhaven}
            name="Beach Haven"
            houseType="Condominium"
            location="Orange Beach"
          />
        </Link>
      </div>
      <p className="text-xl md:text-4xl mt-8 mb-16 text-center text-secondary text-opacity-50">
        select a rental to learn more
      </p>
    </div>
  );
};

export default Home;
